export default {
  // Roles
  roles: false,
  requestStatus: 'idle',

  // Edit role
  currentEditRole: null
};
